import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

// Convert yyyy-mm-dd to yyyymmdd (simple string manipulation to avoid timezone issues)
function formatDateToYmd(dateStr: string): string {
  return dateStr.replace(/-/g, '');
}

export function useAvailableDates() {
  return useQuery({
    queryKey: ['available-dates'],
    queryFn: async (): Promise<string[]> => {
      const { data, error } = await supabase
        .from('available_dates')
        .select('date')
        .order('date', { ascending: false });

      if (error) {
        console.error('Supabase error:', error);
        throw new Error('数据加载失败');
      }

      return (data || []).map((row: { date: string }) => formatDateToYmd(row.date));
    },
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
}
